import { newApi } from "../restdux/index";

export const fileManager = newApi("filedir", "/api/file-dir/");
export const reducer = fileManager.reducer;

export function updateFileDir(data) {
  return fileManager.actions.update(data);
}
